import {css} from '@logistics-frontend/blocks/theme/css'
import {breakpoints, spacing} from '@logistics-frontend/blocks/theme/theme'

import cardSrc from './assets/card-image.svg'

export const classes = {
  paymentCard: css`
    background-image: url(${cardSrc});
    background-repeat: no-repeat;
    background-position: top;
    background-size: contain;
    block-size: ${spacing(25)}; // 200px
  `,
  container: css`
    inline-size: 100%;
    padding: ${spacing(3)}; // 24px

    ${breakpoints.down('sm')} {
      padding: ${spacing(2)}; // 16px
    }
  `,
}
